import { Loader2 } from 'lucide-react';
import React from 'react';

function ButtonLoader({ text, loading, loadingText = "Loading..." }) {
    return (
        loading
            ? <span className='flex gap-3 items-center'>
                <Loader2
                    className='animate-spin'
                />
                <span> {loadingText} </span>
            </span>
            : text
    );
}

export default ButtonLoader;